import { OrderStatus } from "../../data/BaseEntity";

export function orderStatusToName(status: OrderStatus) {
  return statusToName[status];
}

const statusToName = {
  [OrderStatus.INITIAL]: "Potwierdzenie wysłane",
  [OrderStatus.CONFIRMED]: "Podpisane potwierdzenie",
  [OrderStatus.CHECKED_IN]: "Odprawione",
  [OrderStatus.PAID]: "Rozliczone",
  [OrderStatus.CANCELLED]: "Anulowane",
  [OrderStatus.LIST_SENT]: "Lista u dostawcy",
  [OrderStatus.FOR_ADVANCE_PAYMENT]: "FV zaliczkowa wysłana",
  [OrderStatus.ADVANCE_PAID]: "Zaliczkowane",
  [OrderStatus.TO_CANCEL]: "Korekta zamówienia",
  [OrderStatus.CANCELLATION_SENT]: "Anulacja wysłana",
  [OrderStatus.TO_ORDER]: "Do zamówienia",
  [OrderStatus.BOOKING_IN_PROGRESS]: "Rezerwacja w trakcie",
  [OrderStatus.CHANGE_REQUIRED]: "Konieczna zmiana",
  [OrderStatus.TO_MOVE]: "Lista w trakcie",
} as const;
